import {
  LOG_OUT_AFTER
} from "../types";


const logOutAfter= () => {
  return({type: LOG_OUT_AFTER});
};
export default logOutAfter;